import script from "./Whatsapp.vue?vue&type=script&setup=true&lang=js"
export * from "./Whatsapp.vue?vue&type=script&setup=true&lang=js"

import "./Whatsapp.vue?vue&type=style&index=0&id=6faf1ffe&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6faf1ffe"]])

export default __exports__